import React, { InputHTMLAttributes, ReactNode, useState } from 'react';

const ValidIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/valid-icon.svg';
const InvalidIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/invalid-icon.svg';

import Input from '../Input';

export type InputValidationProps = {
  label?: string;
  error?: string;
  invalid?: boolean;
  filled?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export const InputValidation: React.FC<InputValidationProps> = ({
  error,
  label,
  value,
  onFocus: componentOnFocus,
  onBlur: componentOnBlur,
  filled,
  invalid,
  ...props
}) => {
  const hasError = !!error && error.length > 0;
  let iconRight = null;
  if (invalid) iconRight = <img src={InvalidIcon} alt="invalid-icon" />;
  if (!invalid && filled) iconRight = <img src={ValidIcon} alt="valid-icon" />;
  return (
    <>
      <Input
        {...props}
        value={value}
        label={label}
        iconRight={iconRight}
        error={error}
        isNotValid={hasError || invalid}
        isValid={filled && !hasError}
      />
    </>
  );
};
